export default __webpack_public_path__ + "static/media/landscape-foin-sceau-about.6acbfae7.png";